<script lang="ts">
import type { TimeStampType } from "@src/common/TimeStamp";
import EditorStore, { EditorInteractionPointControlOwnership, EditorPlaybackControlOwnership } from "@src/model/Editor.Store";

    import MainStore from "@src/model/Main.Store";
    
    export let text: string = '';
    export let choices: { id: string, text: string, target: TimeStampType }[] = [];    
    
        
    function handleChoiceClick(choice: { id: string, text: string, target: TimeStampType }, e: Event) {
        let x = EditorStore.getValue().currentPlaybackControlOwnership;
        EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.INTERACTION;
        MainStore.setVideoTimeStamp(choice.target);
        EditorStore.getValue().currentPlaybackControlOwnership = x;
        MainStore.setCurrentExecutingInteractionPoint(undefined);
        MainStore.getValue()._currentVideoElement?.play();
    }
    </script>
    
    
    <div class="main-overlay-choose">
        {text}
        <br />
        <div>
            {#each choices as choice}
                <button on:click={(e) => handleChoiceClick(choice, e)}>
                    {choice.id}: {choice.text}
                </button><br />
            {/each}
        </div>
    </div>
    
    
    <style>
        .main-overlay-choose {
            padding: 1rem;
        }
    </style>
    